import React, { useState, memo } from "react"
import Box from "@material-ui/core/Box"
import clsx from "clsx"
import { makeStyles } from "@material-ui/core/styles"
import { useSelector, useDispatch } from "react-redux"
import Radio from "@material-ui/core/Radio"
import RadioGroup from "@material-ui/core/RadioGroup"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import FormControl from "@material-ui/core/FormControl"
import { setCurrentArchiveFilter } from "@/redux/actions//archiveFilterAction"

const useStyles = makeStyles((theme) => ({
    projectFilterDropdownWrapper: {
        backgroundColor: theme.palette.sparcaDarkGrey.main,
        borderRadius: 0,
    },
    sidebarDropdownWrapperEmpty: {
        height: 0,
    },
    projectFilterDropdown: {
        borderRadius: 0,
    },
    productHeader: {
        backgroundColor: theme.palette.sparcaLightBlue.main,
        color: "#ffffff",
        textAlign: "center",
        padding: theme.spacing(1),
    },
    projectFilterContent: {
        padding: theme.spacing(3, 1),
    },
    buttonWrapper: {
        color: "#ffffff",
    },
    button: {
        fontSize: "14px",
        textAlign: "center",
    },
    blueButton: {
        backgroundColor: theme.palette.sparcaDarkBlue.main,
        color: "#ffffff",
        "&:hover": { backgroundColor: theme.palette.sparcaDarkBlue.main, color: "#ffffff" },
    },
    filterButton: {
        marginTop: theme.spacing(4),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    radioGroup: {
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "column",
        justifyContent: "center",
    },
    radioLabel: {
        marginLeft: "0",
        width: "100%",
        textAlign: "center",
    },
}))

const ProjectFilterDropdown = memo(() => {
    const [filterValue, setFilterValue] = useState("all")
    const archiveFilterData = useSelector((state) => state.archiveFilterReducer)
    const dispatch = useDispatch()
    const classes = useStyles()

    const handleChange = (event) => {
        setFilterValue(event.target.value)
        dispatch(setCurrentArchiveFilter(event.target.value))
    }

    return (
        <>
            <Box component="div" className={classes.projectFilterDropdownWrapper}>
                <Box component="div" className={clsx("projectDashboardSidebar", classes.projectFilterDropdown)}>
                    <Box component="div" className="product-wrapper product-sparca">
                        <Box className={classes.projectFilterContent}>
                            <FormControl component="fieldset">
                                <RadioGroup
                                    className={classes.radioGroup}
                                    aria-label="filter"
                                    name="filter"
                                    value={filterValue}
                                    onChange={handleChange}
                                    onClick={(event) => {
                                        setFilterValue(event.target.value)
                                    }}
                                >
                                    <FormControlLabel
                                        className={classes.radioLabel}
                                        value="all"
                                        control={<Radio />}
                                        label={`All Projects(${archiveFilterData.count.all ?? 0})`}
                                        // label="All"
                                    />
                                    <FormControlLabel
                                        className={classes.radioLabel}
                                        value="unarchive"
                                        control={<Radio />}
                                        label={`Active (${archiveFilterData.count.unarchive ?? 0})`}
                                        // label="Unarchive"
                                    />
                                    <FormControlLabel
                                        className={classes.radioLabel}
                                        value="archive"
                                        control={<Radio />}
                                        label={`Archived (${archiveFilterData.count.archive ?? 0})`}
                                        // label="Archive"
                                    />
                                </RadioGroup>
                            </FormControl>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </>
    )
})

export default ProjectFilterDropdown
